import MaterialTable, { MTableHeader } from 'material-table';
import React, { useEffect, useRef, useState } from 'react';
import {
  Accordion, Button, Card, Modal,
} from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import moment from 'moment';
import { tableIcons } from '../../helpers';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../helpers/table';
import useAPI from '../../hooks/useAPI';

export default function BuyProblemsHistoryModal({ buy, onClose }) {
  const [data, setData] = useState({});
  const [selectedComments, setSelectedComments] = useState([]);

  const accordionRef = useRef(null);
  const api = useAPI();

  useEffect(async () => {
    const hists = await api.get(`/buys/${buy.id}/problems`);
    setData(hists);
  }, []);

  const problemColumns = [
    { title: 'Тип проблемы', field: 'buyProblemTypeName' },
    {
      title: 'Дата возникновения проблемы', field: 'createdOn', width: '10%', defaultSort: 'desc', render: ({ createdOn }) => moment.utc(createdOn).format('DD.MM.YYYY HH:mm:ss'),
    },
    {
      title: 'Дата устранения проблемы', field: 'solvedOn', width: '10%', render: ({ solvedOn }) => (solvedOn ? moment.utc(solvedOn).format('DD.MM.YYYY HH:mm:ss') : ''),
    },
  ];

  const commentColumns = [
    {
      title: 'Дата', field: 'createdOn', width: '10%', defaultSort: 'desc', render: ({ createdOn }) => moment.utc(createdOn).format('DD.MM.YYYY HH:mm:ss'),
    },
    { title: 'Комментарий', field: 'message' },
    { title: 'Пользователь', field: 'user', render: ({ user }) => `${user.lastName || ''} ${user.firstName ? `${user.firstName[0]}.` : ''}${user.middleName ? `${user.middleName[0]}.` : ''}` },
  ];

  const showRelatedComments = (problem) => {
    setSelectedComments((prevState) => data.comments.filter((c) => c.createdOn >= problem.createdOn && (!problem.solvedOn || c.createdOn <= problem.solvedOn)));
  };

  return (
    <Modal show={buy} size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        История проблем по закупке
      </Modal.Header>
      <Modal.Body>
        <p>
          № закупки: {buy.num}
        </p>
        <MaterialTable
          options={modifyDefaultOptions({
            toolbar: false, filtering: false, search: false, tableLayout: 'fixed',
          })}
          localization={localization}
          icons={tableIcons}
          columns={problemColumns}
          data={data.problems}
          onRowClick={(event, rowData, togglePanel) => showRelatedComments(rowData)}
        />
        <Accordion style={{ marginTop: '10px' }} defaultActiveKey="0">
          <Accordion.Item eventKey="0" key="0">
            <Accordion.Header ref={accordionRef}>Комментарии к закупке</Accordion.Header>
            <Accordion.Body>
              <MaterialTable
                components={{
                  Header: (props) => (<MTableHeader {...props} style={{ position: 'sticky' }} />),
                }}
                options={modifyDefaultOptions({
                  actionsColumnIndex: -1,
                  toolbar: false,
                  filtering: false,
                  maxBodyHeight: 'calc(100vh - 442px)',
                  headerStyle: { height: 50, zIndex: 0 },
                  filterCellStyle: {
                    position: 'sticky',
                    top: 49,
                    background: 'white',
                  },
                })}
                icons={tableIconsModified}
                localization={localization}
                columns={commentColumns}
                data={selectedComments}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant="secondary">Отмена</Button>
      </Modal.Footer>
    </Modal>
  );
}
